import { AuthProvider, useAuth } from "./providers/authProvider";
import { EnvProvider } from "./providers/envProvider";
import { useRoute } from "./route";
import { LoginScreen } from "./components/LoginScreen";
import { Shell } from "./components/Shell";
import { GroupList } from "./components/GroupList";
import { CaptureList } from "./components/CaptureList";
import { CaptureDetail } from "./components/CaptureDetail";
import { GroupDetail } from "./components/GroupDetail";
import { Settings } from "./components/Settings";
import { InternalList } from "./components/InternalList";

const Routed = () => {
  const route = useRoute();
  if (route.name === "captures")
    return (
      <Shell active="captures">
        <CaptureList params={route.params} />
      </Shell>
    );
  if (route.name === "capture")
    return (
      <Shell active="captures">
        <CaptureDetail id={route.id} />
      </Shell>
    );
  if (route.name === "internal")
    return (
      <Shell active="internal">
        <InternalList />
      </Shell>
    );
  if (route.name === "settings")
    return (
      <Shell active="settings">
        <Settings />
      </Shell>
    );
  if (route.name === "group")
    return (
      <Shell active="groups">
        <GroupDetail id={route.id} />
      </Shell>
    );
  return (
    <Shell active="groups">
      <GroupList params={route.params} />
    </Shell>
  );
};

const Gate = () => {
  const { auth, logout } = useAuth();
  if (auth.status === "loading") return <div className="min-h-screen flex items-center justify-center text-sm text-neutral-500">Loading…</div>;
  if (auth.status === "loggedOut") return <LoginScreen />;
  if (!auth.admin)
    return (
      <div className="min-h-screen flex items-center justify-center p-6 text-center">
        <div className="space-y-3">
          <h1 className="text-lg font-semibold">Not authorized</h1>
          <p className="text-sm text-neutral-500">log-pile is only available to doridium admin accounts.</p>
          <button className="text-sm underline" onClick={logout}>Log out</button>
        </div>
      </div>
    );
  return <Routed />;
};

export const App = () => (
  <AuthProvider>
    <EnvProvider>
      <Gate />
    </EnvProvider>
  </AuthProvider>
);
